import { FC, useState } from 'react'

import { NOW_YEAR } from '../../../configuration'
import * as S from './MonthMultiPicker.styles'
import { Period } from './MonthMultiPicker.types'
import { shortMonthNames } from './MonthMultiPicker.utils'
import { isMonthSelected, MonthPick, monthPickOf } from './monthRangeSelection'

interface MonthRangeGridProps {
  period: Period
  fallbackYear?: number
  onMonthClick: (pick: MonthPick) => void
}

export const MonthRangeGrid: FC<MonthRangeGridProps> = ({
  period,
  fallbackYear = NOW_YEAR,
  onMonthClick,
}) => {
  const [activeYear, setActiveYear] = useState(
    period.start ? monthPickOf(period.start).year : fallbackYear,
  )

  return (
    <>
      <S.YearPicker>
        <S.ChevronLink aria-label="Previous year" onClick={() => setActiveYear(year => year - 1)}>
          <S.IconChevronLeftStyled width={20} />
        </S.ChevronLink>
        <S.SelectedYear>{activeYear}</S.SelectedYear>
        <S.ChevronLink aria-label="Next year" onClick={() => setActiveYear(year => year + 1)}>
          <S.IconChevronRightStyled />
        </S.ChevronLink>
      </S.YearPicker>
      <S.MonthGrid>
        {shortMonthNames.map((monthName, monthIndex) => (
          <S.Month
            key={monthName}
            isSelected={isMonthSelected({ period, pick: { monthIndex, year: activeYear } })}
            onClick={() => onMonthClick({ monthIndex, year: activeYear })}
          >
            {monthName}
          </S.Month>
        ))}
      </S.MonthGrid>
    </>
  )
}
